<template>
  <div>
    <loader :loader="loader" />
    <div class="wrapper-content">
      <v-card border-variant="dark" class="shadow-lg rounded" >
          <div
           :style="{'background-color': this.color}" 
           class="p-5 mt-2">
        <v-row style="color: white; margin-left:6px" align-h="center">
          Datos del médico
        </v-row>
      </div>
        <v-card-text>
          <v-container>
            <v-form>
              <!--<v-row class="mb-2">
                <div class="col-xs-12 col-md-6 col-sm-12 col-lg-4">
                  <strong
                  >Nombre del médico: </strong> <span>{{objMedical.fullNameDoctor}}</span>
                </div>
                <div class="col-xs-12 col-md-6 col-sm-12 col-lg-4">
                  <strong
                  >Cédula No. </strong> <span>{{objMedical.identificationCard}}</span>
                </div>
                <div class="col-xs-12 col-md-6 col-sm-12 col-lg-4">
                  <strong
                  >Profesión: </strong> <span>{{objMedical.academicTitleName}}</span>
                </div>
              </v-row>  -->
                <v-row class="mb-2">
                <div class="col-xs-12 col-md-6 col-sm-12 col-lg-6">
                  <v-text-field
                    label="Nombre completo"
                    v-model="objMedical.fullNameDoctor"
                    prepend-icon="mdi-account"
                    disabled
                  ></v-text-field>
                </div>
              </v-row>

              <v-row class="mb-2">
                <div class="col-xs-12 col-md-6 col-sm-12 col-lg-6">
                  <v-text-field
                    label="Cédula No."
                    v-model="objMedical.identificationCard"
                    prepend-icon="mdi-card-account-details"
                    disabled
                  ></v-text-field>
                </div>
                <div class="col-xs-12 col-md-6 col-sm-12 col-lg-6">
                  <v-text-field
                    label="Título académico"
                    v-model="objMedical.academicTitleName"
                    prepend-icon="mdi-certificate"
                    disabled
                  ></v-text-field>
                </div>
              </v-row>  
              
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
      <v-divider class="mb-5"></v-divider>
      <v-card>
          <div
           :style="{'background-color': this.color}" 
           class="p-5 mt-2">
        <v-row style="color: white; margin-left:6px" align-h="center">
          Datos de consulta
        </v-row>
      </div>
        <v-card-text>
          <v-container>
            <v-form>
              <!--<v-row class="mb-2">
                <div class="col-xs-12 col-md-6 col-sm-12 col-lg-4">
                  <strong
                  >Lugar de atención: </strong> <span>{{objMedical.branchOffice}} - {{objMedical.consultingRoomDestination}}</span>
                </div>
                <div class="col-xs-12 col-md-6 col-sm-12 col-lg-4">
                  <strong
                  >Fecha de atención: </strong> <span>{{objMedical.atentionDate}}</span>
                </div>
              </v-row> -->

              <!--<v-divider class="mb-2"></v-divider>
              <v-subheader>Datos de consulta</v-subheader> -->
              <v-row class="mb-2">
                <div class="col-xs-12 col-md-6 col-sm-12 col-lg-6">
                  <v-text-field
                    label="Lugar de atención"
                    v-model="objMedical.consultingRoomDestination"
                    prepend-icon="mdi-hospital-building"
                    disabled
                  ></v-text-field>
                </div>
                <div class="col-xs-12 col-md-6 col-sm-12 col-lg-6">
                  <VueCtkDateTimePicker
                    :no-value-to-custom-elem="true || false"
                    v-model="objMedical.atentionDate"
                    :min-date="currentDate"
                    disabled
                    button-now-translation="Ahora"
                  >
                    <v-text-field
                      disabled
                      clearable
                      :value="objMedical.atentionDate"
                      prepend-icon="mdi-calendar"
                      label="Fecha de atención"
                      no-autocomplete
                      required
                    ></v-text-field>
                  </VueCtkDateTimePicker>
                </div>
              </v-row>  
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import Encabezado from "@/app/components/base/header/Header.vue";
import Sidebar from "../../components/Sidebar.vue";
import {
  MedicalPracticeRequest,
  PrescriptionRequest,
} from "@/core/request";
import { mapActions } from "vuex";
let token = sessionStorage.tokenUser;
import AutoLogout from "../../components/AutoLogout.vue";
import Loader from "../../components/Loader.vue";
export default {
  components: { Sidebar, Encabezado, AutoLogout, Loader },
  data: () => ({
    loader: false,
    encabezado: { icono: "mdi-pill", texto: "Dispensar prescripción" },
    objMedical: {},
    productsPrescription: [],
    dispensed: {},
    color: '#59805c',
  }),
  computed: {
    currentDate() {
      return moment(new Date()).format("YYYY-MM-DD HH:mm:ss a");
    },
  },
  created() {
    let idMedical = this.$route.params.id;
    this.getMedicalPractice(idMedical);
  },
  methods: {
    ...mapActions(["validTab", "unauthorized"]),
    validBrowserTab() {
      this.validTab();
    },
    getMedicalPractice(id) {
      try{
        this.loader = true;
      let decoded = atob(id);

      MedicalPracticeRequest.listMedicalPracticeQRInfo({
        idMedicalPractice: decoded,
      }).then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
           this.objMedical = res.data.data;
           this.objMedical.atentionDate = moment(
            new Date(this.objMedical.atentionDate)
            ).format("YYYY-MM-DD HH:mm");
            this.objMedical.consultingRoomDestination = this.objMedical.branchOffice +" - "+this.objMedical.consultingRoomDestination
          this.loader = false
        } else if (res.data.code === 401) {
          this.unauthorized();
        }else{
          this.loader = false
        }
      });
      }catch(e){
        this.loader = false
          this.catchError(e);
      }
    },

  },
};
</script>